import ApartmentOutlinedIcon from '@material-ui/icons/ApartmentOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import DashboardIcon from '@material-ui/icons/DashboardOutlined';
import GroupIcon from '@material-ui/icons/Group';
import MessageOutlinedIcon from '@material-ui/icons/MessageOutlined';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import SubjectIcon from '@material-ui/icons/Subject';
import LocalAtmOutlinedIcon from '@material-ui/icons/LocalAtmOutlined';
import BookOutlinedIcon from '@material-ui/icons/ImportContactsOutlined';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import MeetingRoomOutlinedIcon from '@material-ui/icons/MeetingRoomOutlined';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import EmailIcon from '@material-ui/icons/Email';
import AccountLock from '../../../icons/AccountLock';

export const navigationConfig = (t: any, isAdmin: boolean, isCheckIsPrimaryPayer: boolean) => {

    if (!isAdmin && !isCheckIsPrimaryPayer) {
        return [
            {
                title: 'App',
                pages: [
                    {
                        title: t('My Trip'),
                        href: '/dashboard',
                        icon: DashboardIcon
                    },
                ]
            },
            {
                title: 'Support',
                pages: [
                    {
                        title: 'Contact Us',
                        href: '/contact',
                        icon: EmailIcon
                    },
                ]
            }
        ];
    }

    return [
        {
            title: 'App',
            pages: [
                {
                    title: isAdmin? t('Dashboard') : t('My Trip'),
                    href: '/dashboard',
                    icon: DashboardIcon
                },
                {
                    title: t('Pending Approval'),
                    href: '/my_pending_approval',
                    icon: VerifiedUserOutlinedIcon,
                    permission: 'associated.groups.read',
                    notPermission: 'groups.read',
                },
                {
                    title: t('My Groups Overdue Documents'),
                    href: '/my_groups_overdue_documents',
                    icon: NoteAddIcon,
                    permission: 'associated.groups.read',
                    notPermission: 'groups.read',
                },
                {
                    title: t('User Management'),
                    href: '/users',
                    icon: AccountLock,
                    permission: 'user.read',
                    children: [
                        {
                            title: t('Users'),
                            href: '/users',
                            permission: 'user.read',
                        },
                        {
                            title: t('Roles'),
                            href: '/roles',
                            permission: 'role.update',
                        },
                    ]
                },
                {
                    title: t('Events'),
                    href: '/resources',
                    permission: 'resource.read',
                    icon: ApartmentOutlinedIcon,
                },
                {
                    title: t('Group Management'),
                    icon: GroupIcon,
                    permission: ['groups.read'],
                    children: [
                        {
                            title: t('Groups'),
                            href: '/groups',
                            permission: 'groups.read',
                        },
                        {
                            title: t('Group Members'),
                            href: '/groupmembers',
                            permission: 'groups.read',
                        },
                        // {
                        //     title: t('Bookings'),
                        //     href: '/group_bookings',
                        //     permission: 'groups.bookings.read',
                        // },
                        {
                            title: t('Billing Parties'),
                            href: '/billing_party',
                            permission: 'groups.bookings.read',
                        },
                        {
                            title: t('Room Parties'),
                            href: '/room_party',
                            permission: 'groups.bookings.read',
                        },
                    ]
                },
                {
                    title: t('My Groups'),
                    href: '/mygroups',
                    icon: GroupIcon,
                    permission: 'associated.groups.read',
                    notPermission: 'groups.read',
                },
                {
                    title: t('My Group Members'),
                    href: '/my_group_members',
                    icon: PeopleOutlineIcon,
                    permission: 'associated.groups.read',
                    notPermission: 'groups.read',
                },
                // {
                //     title: t('Group Documents'),
                //     href: '/mygroups/documents',
                //     permission: 'associated.groups.read',
                //     notPermission: 'groups.read',
                // },
                {
                    title: t('My Billing'),
                    icon: LocalAtmOutlinedIcon,
                    href: '/my_billing_parties',
                    permission: 'associated.groups.bookings.read',
                    notPermission: 'groups.read',
                },
                {
                    title: t('My Rooms'),
                    icon: MeetingRoomOutlinedIcon,
                    href: '/my_room_parties',
                    permission: 'associated.groups.bookings.read',
                    notPermission: 'groups.read',
                },
                {
                    title: t('My Travelers'),
                    icon: PeopleOutlineIcon,
                    href: '/my_travelers',
                    permission: 'associated.groups.bookings.read',
                    notPermission: 'groups.read',
                },
                {
                    title: t('My Documents'),
                    icon: BookOutlinedIcon,
                    href: '/my_documents',
                    permission: 'associated.groups.bookings.read',
                    notPermission: 'groups.read',
                },
                {
                    title: t('Payments'),
                    icon: LocalAtmOutlinedIcon,
                    href: '/payments',
                    permission: 'payments.read',
                },
                {
                    title: t('My Group Logs'),
                    href: '/my_group_logs',
                    icon: ReceiptOutlinedIcon,
                    permission: 'associated.groups.read',
                    notPermission: 'groups.read',
                },
                {
                    title: t('Admin'),
                    icon: SettingsOutlinedIcon,
                    permission: 'user.update',
                    children: [
                        {
                            title: t('Comms'),
                            href: '/comms',
                            permission: 'communication.update',
                            icon: MessageOutlinedIcon,
                        },
                        {
                            title: t('Credit Card Fee'),
                            href: '/credit_card_fee',
                            permission: 'user.update',
                            icon: LocalAtmOutlinedIcon,
                        },
                        {
                            title: t('Logs'),
                            href: '/logs',
                            permission: 'log.read',
                            icon: ReceiptOutlinedIcon,
                        },
                        {
                            title: t('Reports'),
                            href: '/reports',
                            permission: 'reports.create',
                            icon: AssignmentOutlinedIcon,
                        },
                        {
                            title: t('Netsuite CSV'),
                            href: '/netsuite',
                            permission: 'reports.create',
                            icon: CloudDownloadIcon,
                        },
                        {
                            title: t('Netsuite CSV Groups'),
                            href: '/netsuite_groups',
                            permission: 'reports.create',
                            icon: CloudDownloadIcon,
                        },
                        {
                            title: t('Receipts per Group'),
                            href: '/receipts_per_group',
                            permission: 'reports.create',
                            icon: CloudDownloadIcon,
                        },
                        {
                            title: t('CMS Copy'),
                            href: '/cms_copy',
                            permission: 'cms_copy.update',
                            icon: SubjectIcon,
                        },
                        {
                            title: t('Documents'),
                            icon: BookOutlinedIcon,
                            href: '/documents',
                            permission: 'documents.read',
                        },
                    ]
                },
                {
                    title: t('Email Management'),
                    href: '/email_management',
                    icon: EmailIcon,
                    permission: 'email.read',
                },
            ]
        },
        !isAdmin &&  {
            title: 'Support',
            pages: [
                {
                    title: 'Contact Us',
                    href: '/contact',
                    icon: EmailIcon
                },
            ]
        }
    ]
};

export default navigationConfig;
